import { getCurrentLanguage } from './i18n';
import { addURLSearch, getQueryObj } from './url';

/**
 *
 * 跳转到登陆页
 * @param needToRedirect  跳转去 voov 官网登录页后，登录成功需不需要跳转回 web 入会
 * @param redirectSearch  登录成功跳转回 web 入会，携带的参数
 * @returns
 */
export const gotoLoginPage = (needToRedirect = true, redirectSearch?: Record<string, string>) => {
  if (window.location.pathname.indexOf('/password-login.html') > -1) {
    return false;
  }

  let url = `${getCurrentLanguage() === 'zh-CN' ? '/sg' : ''}/password-login.html`;

  if (needToRedirect) {
    const searchParams = new URLSearchParams(window.location.search);
    if (redirectSearch) {
      Object.keys(redirectSearch).forEach((key) => {
        searchParams.set(key, redirectSearch[key]);
      });
    }
    // searchParams.size有兼容性
    let searchParamsSize = 0;
    searchParams.forEach(() => {
      searchParamsSize = searchParamsSize + 1;
    });
    url = addURLSearch({
      url,
      query: {
        redirect_type: '3',
        redirect_link: searchParamsSize
          ? `${window.location.pathname}?${searchParams.toString()}`
          : window.location.pathname,
        lang: getCurrentLanguage(),
      },
    });
  }

  window.location.href = url;
};

/**
 * @description 去注册页面
 */
export const gotoSignPage = () => {
  const iframeSrc = encodeURIComponent(
    `/mobile/fillInRegionAndBirth.html?page=fillInRegionAndBirth&platform=web&from_page=register&region=df&lang=${getCurrentLanguage()}&scheme=register&redirect_link=${
      window.location.pathname
    }${window.location.search}&redirect_type=2`,
  );
  window.location.href = `${window.location.origin}/container.html?src=${iframeSrc}`;
};
/**
 * 跳转到 web 入会首页
 *
 * important: 不是通过单页路由的形式跳转，状态被全部消息
 */
export const gotoHomePage = () => {
  window.location.href = addURLSearch({
    url: process.env.REACT_APP_BASENAME,
    query: getQueryObj(),
  });
};

/**
 * 刷新页面
 */
export const reload = () => {
  window.location.reload();
};

/**
 * @description 调回首页
 */
export const gotoHomePageWithMeetingCode = (meetingCode: string) => {
  window.location.href = addURLSearch({
    url: process.env.REACT_APP_BASENAME,
    query: {
      ...getQueryObj(),
      code: meetingCode,
    },
  });
};

/**
 * @description 去用户中心
 */
export const gotoUserCenter = () => {
  window.location.href =
    getCurrentLanguage() === 'zh-CN'
      ? `${window.location.origin}/user-center/personal-information`
      : `${window.location.origin}/user-center/personal-information`;
};
